<template>
  <div>
    <p class="mt-1">
      Equal population districts is
      <a
        href="https://redistricting.lls.edu/redistricting-101/where-are-the-lines-drawn/"
        target="_blank"
        >just the first step</a
      >
      to ensure fair representation through redistricting.
    </p>

    <p>
      Other factors need to be considered, such as ensuring that redrawn
      districts
      <a
        href="https://redistricting.lls.edu/redistricting-101/where-are-the-lines-drawn/#minority+representation"
        target="_blank"
        >do not harm voters of color</a
      >, and that
      <a
        href="https://redistricting.lls.edu/redistricting-101/where-are-the-lines-drawn/#communities+of+interest"
        target="_blank"
        >communities of interest are preserved</a
      >. The charts below show
      <strong
        >{{ postgres.districtname }}'s population by race &amp; Hispanic
        origin</strong
      >
      according to the 2020 Census.
    </p>

    <!-- <PieChart :geoid="postgres.geoid" :popType="'cvap'"/> -->
     <PieChart v-if="postgres.geoid" :legBody="'congress'" :geoid="postgres.geoid"/>

    <p class="text-caption">
      Note: "Amer. Indian/AK Native" = American Indian/Alaska Native;<br />"Nat.
      Haw./Other PI" = Native Hawaiian/Other Pacific Islander
      <br />
      <em>Percentages may not total 100% due to rounding.</em>
    </p>

<!-- <ul>
  <li>
    The Hispanic population increased/decreased {{ (postgres.hisptotchgpct1019 * 100).toFixed(1) }}% (from {{ postgres.hisptot10 }} to {{ postgres.hisptot19 }})
  </li>
</ul>-->

  </div>
</template>
<script>
import { Enums } from "../../../../data/Config/Config";
import PieChart from "../../PieChart";
export default {
  name: "DemograhicsCongress",
  components: {
      PieChart
  },
  data: function () {
    return {};
  },
  mounted: function () {},
  methods: {},
  watch: {},
  computed: {
    postgres: function () {
      return (
        this.$store.getters.getSelectedData[Enums.DATA_SOURCE.POSTGRES] || {}
      );
    },
  },
};
</script>
<style></style>